import axios from 'axios';
import {
  CREATE_JOB_DETAILS_URL,
  GET_JOB_PROFILE_DETAILS_URL,
} from '@/utils/constants/constants.js';

function build_loaded_job_profile(data, jobId, normalize_sections) {
  const profile_title = get_loaded_job_profile_title(data);
  return {
    id: get_loaded_job_profile_id(data, jobId),
    title: profile_title,
    description: get_loaded_job_profile_description(data),
    sections: normalize_sections(data.sections || [])
  };
}
function get_loaded_job_profile_id(data, jobId) {
  return data.id || jobId;
}
function get_loaded_job_profile_title(data) {
  return data.job_title || data.title || 'Untitled Job Profile';
}
function get_loaded_job_profile_description(data) {
  return data.description || '';
}
function get_job_profile_response_data(response) {
  const wrapper = response.data || {};
  return wrapper.data || wrapper;
}
function is_valid_job_profile_data(data) {
  return data && typeof data === 'object';
}

const methods = {
    async load_job_profile() {
      if (!this.jobId) return;
      this.loading = true;
      try {
        const data = await this.fetch_job_profile_data();
        this.apply_loaded_job_profile(data);
      } catch (error) {
        this.handle_job_profile_load_error(error);
      } finally {
        this.loading = false;
      }
    },
    async fetch_job_profile_data() {
      const response = await axios.get(GET_JOB_PROFILE_DETAILS_URL, {
        headers: this.headers,
        params: { entity_type_id: this.jobId },
      });
      const data = get_job_profile_response_data(response);
      if (is_valid_job_profile_data(data)) return data;
      throw new Error('Invalid response structure');
    },
    apply_loaded_job_profile(data) {
      this.form_detail = build_loaded_job_profile(data, this.jobId, this.normalize_sections);
      this.sections = this.clone_sections_for_edit(this.form_detail.sections);
      this.source_file_name = data.source_file_name || '';
      this.source_file_url = data.source_file_url || '';
      this.replacement_job_profile_file = null;
      if (this.mode === 'edit') this.$nextTick(() => this.init_editors());
    },
    handle_job_profile_load_error(error) {
      this.show_error(`Failed to load job profile: ${error.response?.data?.message || error.message}`);
      this.form_detail = { id: null, title: '', description: '', sections: [] };
      this.source_file_name = '';
      this.source_file_url = '';
      this.replacement_job_profile_file = null;
    },

    on_replacement_job_file_selected(event) {
      const files = event?.target?.files || [];
      this.replacement_job_profile_file = files.length ? files[0] : null;
    },

    async upload_replacement_job_profile_file() {
      if (!(this.replacement_job_profile_file instanceof File)) return;

      const form_data = new FormData();
      form_data.append('entity_type_id', String(this.jobId));
      form_data.append('file', this.replacement_job_profile_file);

      await axios.post(CREATE_JOB_DETAILS_URL, form_data, {
        headers: {
          ...this.headers,
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
      });
    },
};

export default methods;

